import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3, Camera, Mic, LayoutDashboard } from 'lucide-react';

const bentoFeatures = [
  {
    icon: <BarChart3 className="text-violet-600 w-7 h-7" />,
    title: 'Cálculos de Margem Instantâneos',
    description: 'A IA calcula suas margens em segundos e te entrega as respostas formatadas em tabelas cristalinas direto no chat, sem nunca ter que abrir planilhas.',
    colSpan: 'md:col-span-2',
    rowSpan: 'md:row-span-1',
    bg: 'bg-white',
    wrapperClass: 'flex flex-col justify-between'
  },
  {
    icon: <Camera className="text-blue-500 w-7 h-7" />,
    title: 'Análise por Foto',
    description: 'Fotografe a bomba ou produto. O LUK puxa os dados reais instantaneamente.',
    colSpan: 'md:col-span-1',
    rowSpan: 'md:row-span-2',
    bg: 'bg-gradient-to-br from-blue-50 to-white',
    wrapperClass: 'flex flex-col'
  },
  {
    icon: <Mic className="text-emerald-500 w-7 h-7" />,
    title: 'Comandos por Áudio',
    description: 'Mande um áudio pedindo o movimento do turno. Mais rápido que digitar.',
    colSpan: 'md:col-span-1',
    rowSpan: 'md:row-span-1',
    bg: 'bg-gradient-to-br from-emerald-50 to-white',
    wrapperClass: 'flex flex-col justify-end'
  },
  {
    icon: <LayoutDashboard className="text-rose-500 w-7 h-7" />,
    title: 'Dashboards Sob Demanda',
    description: 'Peça "O gráfico de vendas" e a IA envia um link mágico com a visualização.',
    colSpan: 'md:col-span-1',
    rowSpan: 'md:row-span-1',
    bg: 'bg-gradient-to-br from-rose-50 to-white',
    wrapperClass: 'flex flex-col justify-end'
  }
];

export default function IAFeaturesBento() {
  return (
    <section className="py-32 bg-[#FCFCFD] relative overflow-hidden font-sans">
      
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-gradient-radial from-slate-100 to-transparent rounded-full -z-10 translate-x-1/3 -translate-y-1/3" />
      
      <div className="container mx-auto px-6 max-w-6xl relative z-10">
        
        <div className="grid grid-cols-1 md:grid-cols-3 md:grid-rows-2 gap-6 auto-rows-[280px]">
          {/* Header Tile */}
          <div className="md:col-span-1 md:row-span-2 flex flex-col justify-center p-6 lg:p-10">
             <motion.h2 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="text-4xl sm:text-5xl lg:text-[56px] font-black text-slate-900 mb-6 tracking-tighter leading-[0.95]"
              >
                Simples.<br/>
                <span className="text-violet-600">Poderoso.</span>
             </motion.h2>
             <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
                className="text-slate-500 text-lg sm:text-xl font-medium leading-relaxed tracking-tight"
             >
                A tecnologia mais avançada já desenvolvida para a gestão de postos de combustível, desenhada para desaparecer no processo.
             </motion.p>
          </div>

          {/* Bento Tiles */}
          {bentoFeatures.map((feature, idx) => (
             <motion.div
                key={idx}
                initial={{ opacity: 0, scale: 0.95, y: 20 }}
                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.2 + (idx * 0.1), ease: [0.16, 1, 0.3, 1] }}
                className={`${feature.colSpan} ${feature.rowSpan} ${feature.bg} ${feature.wrapperClass} p-8 lg:p-10 rounded-[2.5rem] border border-slate-200/80 shadow-[0_8px_30px_rgba(0,0,0,0.04)] hover:shadow-[0_20px_60px_rgba(0,0,0,0.08)] hover:-translate-y-1 transition-all duration-500 group overflow-hidden relative`}
             >
                <div className="w-14 h-14 rounded-[1.25rem] bg-white shadow-sm border border-slate-100 flex items-center justify-center mb-auto group-hover:scale-110 transition-transform duration-500 z-10">
                  {feature.icon}
                </div>
                <div className="mt-8 z-10">
                  <h3 className="text-2xl lg:text-3xl font-bold text-slate-900 mb-4 tracking-tight leading-tight">{feature.title}</h3>
                  <p className="text-slate-500/90 font-medium leading-relaxed text-[15px] max-w-sm">{feature.description}</p>
                </div>
             </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}
